export { default } from './validate-bootstrap-data';
